import { VbzButton, VbzModal } from '@smiles/voebiz-ui-kit';
import React, { FC } from 'react';
import { ModalBody } from 'reactstrap';

interface ModalRulesProps {
  isOpenModalRules: boolean;
  toggleModalRules: () => void;
  promoRule: string;
  onClick: () => void;
}

const ModalRules: FC<ModalRulesProps> = ({ isOpenModalRules, toggleModalRules, promoRule, onClick }) => {
  return (
    <>
      <VbzModal isOpen={isOpenModalRules} type="right" desktopSize="small" toggle={onClick}>
        <ModalBody>
          <div
            className="modal-rules-content"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: `${promoRule}` }}
          />
          <div className="continue-modal-btn">
            <VbzButton
              id="continue-modal-btn"
              className="continue-modal-button"
              color="primary"
              text="Continuar"
              onClick={onClick}
            />
          </div>
          <div className="back-modal-btn">
            <VbzButton type="button" text="voltar" color="hyperlink" onClick={onClick} />
          </div>
        </ModalBody>
      </VbzModal>
    </>
  );
};
export default ModalRules;
